import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import NotificationSystem from 'react-notification-system';
import { Link } from 'react-router-dom';
import loadImage from 'image-promise';

import {loginUser} from '../../actions/user_actions';
import {Spinner} from "../../components/Loading/Spinner";


class LoginForm extends Component {

    constructor(props) {
        super(props);

        this.state = {
            username: '',
            password: '',
            button_disabled: false,
            failed_login_shown: false,
            _notificationSystem: null
        }
    }

    _handleInputUsername = (ev) => {
        this.setState({username: ev.target.value.toLowerCase()})
    };

    _handleInputPassword = (ev) => {
        this.setState({password: ev.target.value})
    };

    _handleSubmit = (ev) => {
        ev.preventDefault();

        if (this.state.username === '' || this.state.password === '') {
            this.state._notificationSystem.addNotification({
                title: 'Credenciales faltantes',
                message: 'Por favor, ingrese email y contraseña.',
                level: 'error',
                position: 'bc',
                dismissible: false
            });
            return false;
        }

        // console.log("--- SUBMISSION ---");
        this.setState({button_disabled: true, failed_login_shown: false});

        // Try to login User
        this.props.loginUser(this.state.username, this.state.password);
    };

    componentDidMount() {
        this.setState({_notificationSystem: this.refs.notificationSystem});
        loadImage('/static/images/login/login.jpg').then(() => {
            document.querySelector('.main-login').classList.add('main-login-big-image');
        });
    }


    componentWillReceiveProps(nextProps){
        if(nextProps.user && nextProps.user.username == null){
            if(this.state.failed_login_shown === true){
                this.setState({button_disabled: false});
            }else{
                this.setState({button_disabled: false, failed_login_shown: true});
                this.state._notificationSystem.addNotification({
                    title: 'Error en la contraseña',
                    message: 'Su usuario o contraseña es incorrecto. Por favor, vuelva a intentarlo.',
                    level: 'error',
                    position: 'bc',
                    dismissible: false,
                    onRemove: () => {
                        this.setState({recovery_error: false});
                    }
                });
            }
        }
    }

    render() {

        return (
            <div>
                <div className="valign-wrapper main-login">
                    <div className="login-container text-center">
                        <div className="form-login">
                            <form>
                                <h4 className="text-center bold" style={{fontSize:30}}>¡Bienvenido a Shell Fame & Ethanol!</h4>
                                <div className="row">
                                    <div className="input-field col s12">
                                        <input value={this.state.username} type="text" placeholder="Ingrese su usuario o email"
                                               onChange={this._handleInputUsername}/>
                                        <label className="active"> Usuario o Email</label>
                                    </div>
                                    <div className="input-field col s12">
                                        <input value={this.state.password} type="password"
                                               placeholder="Ingrese su contraseña"
                                               onChange={this._handleInputPassword}  autocomplete="off"/>
                                        <label className="active">Contraseña</label>
                                    </div>
                                    <div className="input-field col s12">
                                        {this.state.button_disabled ? <Spinner/> :
                                            <button type="submit" ref="loginButton"
                                                    className={`btn btn-yellow z-depth-0 margin-bottom-10 ${this.state.button_disabled ? 'disabled' : ''}`}
                                                    onClick={this._handleSubmit}>Ingresar
                                            </button>
                                        }
                                    </div>

                                </div>
                                <div>
                                    <Link to='/forgot-password' className="text-center shell-red-text" style={{fontSize:16}}>
                                        Olvidé mi contraseña</Link>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <NotificationSystem ref="notificationSystem"/>
            </div>

        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user
    }
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({loginUser}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginForm);



// WEBPACK FOOTER //
// ./src/containers/Login/login.js